import styled from 'styled-components';
import { themeGet } from 'styled-system';

export const RenderAsHTMLStyles = styled.div`
  p {
    margin-bottom: 15px;
    margin-top: 0rem;
  }

  p:first-child {
    margin: 0;
    margin-bottom: 15px;
  }

  strong {
    display: inline-block;
  }

  p:empty {
    height: 1px;
    margin-bottom: 0px;
  }

  img {
    width: 100%;
  }

  p:only-child {
    margin: 0;
  }

  ul {
    list-style: initial;
  }
  ol {
    list-style: decimal;
  }

  ul,
  ol {
    padding-inline-start: 20px;
    margin: 1rem 0;
  }

  li {
    margin: 0.25rem 0;
  }
  blockquote {
    background: ${themeGet('colors.bgPrimary')};
    border-left: 5px solid ${themeGet('colors.iceBlueTwo')};
    margin: 1em 10px;
    padding: 0.5em 10px;
  }

  blockquote p {
    display: inline;
  }
`;
